import { GridRow } from '../../../types/types';

// Loaded grid rows keep the export in the order the user sees, but only when they are
// provably the whole result set and already carry every requested column.
export const canExportLoadedRows = (
  rows: GridRow[],
  totalCount: number | undefined,
  itemNames: string[]
): boolean => {
  if (
    totalCount === undefined ||
    rows.length === 0 ||
    rows.length < totalCount
  ) {
    return false;
  }

  // Sample every row: an API that omits empty fields would otherwise defeat the check.
  return itemNames.every((name) => rows.some((row) => name in row));
};
